import { InboxOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, InputNumber, Spin } from 'antd';
import CountDownFinal from 'components/Header/CountDownFinal';
import HotScheduleModal from 'components/Header/HotScheduleModal';
import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import qs from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import {
  createPredictions,
  getAllSetting,
  getFP,
  getIP,
  getMatchList,
  getTime
} from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE } from 'utils/common/const';
const pub = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

const leagues = [
  {
    id: 8,
    name: 'FIFA World Cup',
    logo: 'https://att-bucket.sgp1.cdn.digitaloceanspaces.com/logo/wc-2026.png'
  },
  {
    id: 1,
    name: 'UEFA Champions League',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497929435-612792753.png'
  },
  {
    id: 2,
    name: 'UEFA Europa League',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776498120520-357985285.png'
  },
  {
    id: 3,
    name: 'English Premier League',
    logo: 'https://loodibee.com/wp-content/uploads/Premier-League-Logo.png'
  },
  {
    id: 4,
    name: 'La Liga',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497700383-85707437.png'
  },
  {
    id: 5,
    name: 'Italian Serie A',
    logo: 'https://1000logos.net/wp-content/uploads/2019/01/Italian-Serie-A-Logo.png'
  },
  {
    id: 6,
    name: 'German Bundesliga',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497741004-506738821.png'
  },
  {
    id: 7,
    name: 'France Ligue 1',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497881490-491170157.png'
  }
];

function formatPredictionCountdown(remainingMs) {
  if (remainingMs <= 0) return '00:00:00';
  const totalSec = Math.floor(remainingMs / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

function MatchPredictionCountdown({ deadline, timeServer }) {
  const serverOffsetMs = useRef(0);
  useEffect(() => {
    if (timeServer != null && timeServer !== '') {
      const t = new Date(timeServer).getTime();
      if (!Number.isNaN(t)) serverOffsetMs.current = t - Date.now();
    }
  }, [timeServer]);
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), 1000);
    return () => window.clearInterval(id);
  }, []);
  const end =
    deadline instanceof Date ? deadline : deadline != null ? new Date(deadline) : new Date(0);
  const rem = end.getTime() - (Date.now() + serverOffsetMs.current);
  return <>{formatPredictionCountdown(rem)}</>;
}

const HomePage = () => {
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [listDataMatch, setListDataMatch] = useState([]);
  const [timeServer, setTimeServer] = useState(null);
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [dataSettings, setDataSettings] = useState([]);

  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'today', 'tomorrow', 'day3', 'day4', 'day5'
  const [isHotScheduleOpen, setIsHotScheduleOpen] = useState(false);

  // Hàm lọc trận đấu theo tab được chọn
  const getFilteredMatches = () => {
    if (!listDataMatch || listDataMatch.length === 0) return [];

    const now = dayjs();
    const today = now.format('YYYY-MM-DD');
    const tomorrow = now.add(1, 'day').format('YYYY-MM-DD');
    const day3 = now.add(2, 'day').format('YYYY-MM-DD');
    const day4 = now.add(3, 'day').format('YYYY-MM-DD');
    const day5 = now.add(4, 'day').format('YYYY-MM-DD');

    switch (activeTab) {
      case 'today':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === today;
        });
      case 'tomorrow':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === tomorrow;
        });
      case 'day3':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === day3;
        });
      case 'day4':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === day4;
        });
      case 'day5':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === day5;
        });
      case 'all':
      default:
        return listDataMatch;
    }
  };

  const handleLeagueClick = (leagueId) => {
    setSelectedLeagues((prevSelectedLeagues) =>
      prevSelectedLeagues.includes(leagueId)
        ? prevSelectedLeagues.filter((id) => id !== leagueId)
        : [...prevSelectedLeagues, leagueId]
    );
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const leagueListRef = React.createRef();

  const scrollLeft = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft - 100);
    }
  };

  const scrollRight = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft + 100);
    }
  };

  useEffect(() => {
    fetchAllSetting();
    fetchIP();
    fetchFP();
    fetchTimeServer();

    // Load saved account name from localStorage
    const savedAccount = localStorage.getItem('userAccount');
    if (savedAccount) {
      form.setFieldsValue({ account: savedAccount });
    }
  }, [form]);

  useEffect(() => {
    fetchDataScheduByLS();
  }, []);

  const fetchIP = async () => {
    try {
      const res = await getIP();
      setIP(res);
    } catch (e) {}
  };

  const fetchFP = async () => {
    try {
      const res = await getFP();
      setFP(res);
    } catch (e) {}
  };

  const fetchTimeServer = async () => {
    try {
      const res = await getTime();
      setTimeServer(res);
    } catch (e) {}
  };

  const fetchDataScheduByLS = async () => {
    try {
      setIsLoading(true);
      const res2 = await getMatchList({
        site: CONST_SITE.OPEN88
      });

      const dataMatch2 =
        res2?.data?.length > 0
          ? res2.data.map((item) => {
              const formatCountDown = dayjs.unix(item.startTime);
              return { ...item, countdown: new Date(formatCountDown) };
            })
          : [];

      setListDataMatch(dataMatch2 || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching match list:', error);
      setIsLoading(false);
    }
  };

  const fetchAllSetting = async (data) => {
    try {
      setIsLoading(true);
      const res = await getAllSetting(qs.stringify({ site: CONST_SITE.OPEN88 }));
      setDataSettings(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const TIMEOUT_DURATION = 10000; // 10 seconds

  const createPredictionsWithTimeout = (predictions) => {
    return Promise.race([
      createPredictions(predictions),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), TIMEOUT_DURATION)
      )
    ]);
  };

  const onFinishForm = async (data) => {
    try {
      const filteredMatches = getFilteredMatches();
      if (filteredMatches?.length === 0) return;

      if (!data?.account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đăng nhập!'
        });
        return;
      }

      // Validate that both home and away scores are provided for each match
      const hasInvalidScores = Object.entries(data).some(([key, value]) => {
        // Bỏ qua field account và các field không phải score
        if (key === 'account' || !key.includes('_')) return false;

        const parts = key.split('_');
        if (parts.length !== 2) return false;

        const [scoreType, matchId] = parts;
        if (!['homeScore', 'awayScore'].includes(scoreType)) return false;

        const otherScoreType = scoreType === 'homeScore' ? 'awayScore' : 'homeScore';
        const otherScoreKey = `${otherScoreType}_${matchId}`;
        const otherValue = data[otherScoreKey];

        // Kiểm tra nếu một trong hai score có giá trị nhưng score kia không có
        const hasValue = value !== undefined && value !== null && value !== '';
        const hasOtherValue = otherValue !== undefined && otherValue !== null && otherValue !== '';

        if (hasValue && !hasOtherValue) {
          return true;
        }

        return false;
      });

      if (hasInvalidScores) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập đầy đủ cả hai bên tỉ số cho mỗi trận đấu!'
        });
        return;
      }

      setIsLoadingSubmit(true);

      const resultGroup = groupScoresByMatchId(data, IP, FP, filteredMatches);

      if (resultGroup.length === 0) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng dự đoán ít nhất một trận đấu!'
        });
        setIsLoadingSubmit(false);
        return;
      }

      const res = await createPredictionsWithTimeout(resultGroup);
      if (res?.code === 0) {
        // Save account name to localStorage on successful submission
        localStorage.setItem('userAccount', data.account);

        notification.success({
          message: 'Thành công',
          description: 'Dự đoán tỉ số thành công!'
        });
        form.resetFields(Object.keys(form.getFieldsValue()).filter((key) => key !== 'account'));
      } else {
        if (res.valid === false) {
          notification.error({
            message: res.title_mess,
            description: res?.text_mess
          });
        } else {
          notification.error({
            message: 'Lỗi',
            description: res?.message
          });
        }
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    if (!errorInfo?.values?.account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tên đang nhập!'
      });
    } else {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng điền đầy đủ thông tin!'
      });
    }
  };

  const onFinishCountDown = () => {
    console.log('Countdown finished');
  };

  const groupScoresByMatchId = (input, ip, fp, matchInfo) => {
    const groupedMatches = Object.entries(input).reduce((acc, [key, value]) => {
      if (key === 'account') return acc;

      const parts = key.split('_');
      if (parts.length !== 2) return acc;

      const [scoreType, matchId] = parts;
      if (!matchId || !['homeScore', 'awayScore', 'sameScore'].includes(scoreType)) return acc;

      // Kiểm tra giá trị hợp lệ
      if (value === undefined || value === null || value === '') return acc;

      if (!acc[matchId]) {
        acc[matchId] = {
          matchId,
          account: input.account,
          homeScore: undefined,
          awayScore: undefined,
          sameScore: undefined
        };
      }

      if (scoreType === 'homeScore') {
        acc[matchId].homeScore = value;
      } else if (scoreType === 'awayScore') {
        acc[matchId].awayScore = value;
      } else if (scoreType === 'sameScore') {
        acc[matchId].sameScore = value;
      }

      return acc;
    }, {});

    return Object.values(groupedMatches)
      .filter(
        (match) =>
          match.homeScore !== undefined &&
          match.awayScore !== undefined &&
          match.sameScore !== undefined &&
          match.homeScore !== null &&
          match.awayScore !== null &&
          match.sameScore !== null &&
          match.homeScore !== '' &&
          match.sameScore !== '' &&
          match.awayScore !== ''
      )
      .map(({ matchId, account, homeScore, awayScore, sameScore }) => {
        const matchDetails = matchInfo.find(
          (match) => parseInt(match.matchId) === parseInt(matchId)
        );

        return {
          matchId,
          homeScore,
          awayScore,
          sameScore,
          account,
          ip,
          fp,
          homeName: matchDetails ? matchDetails.homeName : 'Unknown',
          awayName: matchDetails ? matchDetails.awayName : 'Unknown',
          site: SITE
        };
      });
  };

  const showListItemMatch = (matchList) => {
    if (!matchList || matchList.length <= 0) {
      return (
        <div className="flex flex-col items-center justify-center py-8">
          <InboxOutlined className="text-6xl text-gray-300 mb-4" />
          <p className="text-center text-gray-500">Không có trận đấu nào để dự đoán</p>
        </div>
      );
    } else {
      const filteredMatchList =
        selectedLeagues.length > 0
          ? matchList.filter((item) =>
              selectedLeagues.includes(
                leagues.find((league) => league.name === item.leagueName)?.id
              )
            )
          : matchList;

      const filteredByTime = filteredMatchList.filter((item) => timeServer <= item.countdown);

      const itemMatch = filteredByTime.map((item, index) => {
        // const matchDayOfWeek = daysOfWeek[dayjs(item.startTime * 1000).format('dddd')]; // Calculate day of week for each match
        return (
          <div
            key={index}
            className="w-full max-w-[885px] mx-auto border border-[#FB8C00] rounded-2xl px-3 md:px-6 pb-4 md:pb-6 pt-0 relative"
            style={{
              boxShadow: 'inset 0px 0px 10.574px rgba(0, 0, 0, 0.09)',
              backgroundImage: "url('/assets/images/match/bg.png')",
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              backgroundPosition: 'center'
            }}
          >
            <div className="relative top-[-12px] md:top-[-15px] w-full flex justify-center mb-3 md:mb-2">
              <div
                className="rounded-b-2xl px-4 md:px-6 h-10 md:h-12 flex items-center justify-center min-w-[220px] md:min-w-[300px]"
                style={{
                  backgroundImage: "url('/assets/images/match/bg_league.png')",
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'center'
                }}
              >
                <p className="font-bold text-sm md:text-lg leading-6 text-white text-center mb-0 whitespace-nowrap">
                  {item.leagueName}
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-2 md:gap-3 justify-center items-center mb-3">
              <div className="bg-white rounded-[17px] h-[44px] md:h-[50px] w-full md:w-[330px] px-4 flex items-center justify-center shadow-[0px_4px_4px_rgba(0,83,223,0.13)]">
                <p className="mb-0 text-[13px] md:text-[14px] font-medium text-black">
                  Thời gian dự đoán còn:
                </p>
                <p className="mb-0 ml-2 text-[13px] md:text-[14px] font-semibold text-[#F56522] tabular-nums">
                  <MatchPredictionCountdown deadline={item.countdown} timeServer={timeServer} />
                </p>
              </div>
              <div className="bg-white rounded-[17px] h-[44px] md:h-[50px] w-full md:w-[330px] px-4 flex items-center justify-center shadow-[0px_4px_4px_rgba(0,83,223,0.13)]">
                <p className="mb-0 text-[13px] md:text-[14px] font-medium text-black">
                  Thời gian kết thúc:
                </p>
                <p className="mb-0 ml-2 text-[13px] md:text-[14px] font-semibold text-[#F56522]">
                  {dayjs(item.startTime * 1000).format('HH:mm')}
                </p>
              </div>
            </div>

            <div className="!mt-6 w-full mx-auto mb-5 flex items-center justify-center">
              <div className="relative w-full max-w-[520px] h-[65px] md:h-[54px] flex items-center justify-between">
                {/* Center orange bar (mobile design node 147:1113) */}
                <div
                  className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-[90%] h-[39px] rounded-[6px]"
                  style={{
                    background: '#F56522',
                    boxShadow: 'inset 0px 0px 14.36px rgba(254, 173, 0, 1)'
                  }}
                />

                {/* Home logo */}
                <div className="relative z-10 w-[65px] h-[65px] rounded-full bg-white border border-[#F56522] shadow-[inset_0px_0px_3.9px_0.7px_rgba(0,0,0,0.25)] p-1 shrink-0">
                  <img
                    alt={item.homeName}
                    className="w-full h-full object-contain"
                    src={item.homeLogo}
                  />
                </div>

                {/* Home name */}
                <p className="relative z-10 mb-0 text-[12px] font-medium text-white text-center w-[110px] px-1 leading-[1.1]">
                  {item.homeName}
                </p>

                {/* VS */}
                <div className="relative z-10 w-[61px] h-[61px] p-1 shrink-0">
                  <img
                    src="/assets/images/match/VS.png"
                    alt="VS"
                    className="w-full h-full object-contain"
                  />
                </div>

                {/* Away name */}
                <p className="relative z-10 mb-0 text-[12px] font-medium text-white text-center w-[110px] px-1 leading-[1.1]">
                  {item.awayName}
                </p>

                {/* Away logo */}
                <div className="relative z-10 w-[65px] h-[65px] rounded-full bg-white border border-[#F56522] shadow-[inset_0px_0px_3.9px_0.7px_rgba(0,0,0,0.25)] p-1 shrink-0">
                  <img
                    alt={item.awayName}
                    className="w-full h-full object-contain"
                    src={item.awayLogo}
                  />
                </div>
              </div>
            </div>

            <div className="flex mt-1 items-center justify-center gap-3 mb-2">
              <Form.Item className="mb-0 md:mr-6 lg:mr-10" name={`homeScore_${item.matchId}`}>
                <InputNumber
                  disabled={timeServer > item.countdown}
                  controls={false}
                  min={0}
                  max={99}
                  maxLength={2}
                  placeholder="Nhập số"
                  className="bg-white border-0 text-center font-semibold text-base text-[#676767] rounded-[10px] shadow-[inset_0px_1.057px_4.23px_rgba(0,0,0,0.29)]"
                  style={{
                    textAlign: 'center',
                    width: '136px',
                    height: '40px'
                  }}
                />
              </Form.Item>
              <p className="mb-0 text-sm md:text-lg font-bold text-black">Tỉ số</p>
              <Form.Item className="mb-0 md:ml-6 lg:ml-10" name={`awayScore_${item.matchId}`}>
                <InputNumber
                  disabled={timeServer > item.countdown}
                  controls={false}
                  min={0}
                  max={99}
                  maxLength={2}
                  placeholder="Nhập số"
                  className="bg-white border-0 text-center font-semibold text-base text-[#676767] rounded-[10px] shadow-[inset_0px_1.057px_4.23px_rgba(0,0,0,0.29)]"
                  style={{
                    textAlign: 'center',
                    width: '136px',
                    height: '40px'
                  }}
                />
              </Form.Item>
            </div>

            <div className="flex flex-col gap-3 items-center justify-center">
              <div className="w-full md:w-[290px] bg-white rounded-[10px] h-[40px] flex items-center shadow-[inset_0px_1.057px_4.23px_rgba(0,0,0,0.29)] px-2">
                <Form.Item className="mb-0 w-full" name={`sameScore_${item.matchId}`}>
                  <InputNumber
                    disabled={timeServer > item.countdown}
                    controls={false}
                    min={0}
                    maxLength={5}
                    placeholder="Số người dự đoán giống bạn"
                    className="w-full !border-0 !shadow-none !h-[36px] text-center font-semibold text-[14.8px] text-[#676767] [&_.ant-input-number-input]:!h-full [&_.ant-input-number-input]:!leading-[36px] [&_.ant-input-number-input]:!p-0"
                  />
                </Form.Item>
              </div>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoadingSubmit}
                aria-label="Xác nhận"
                className="h-[44px] w-[160px] min-w-[160px] rounded-[4px] border-0 p-0 shadow-none bg-transparent hover:!bg-transparent focus:!bg-transparent"
                style={{
                  backgroundImage: "url('/assets/images/match/btnDudoan.png')",
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'center'
                }}
              />
            </div>
            <p className="text-center mt-2 text-sm md:text-base font-medium text-black">
              Trước{' '}
              <span className="font-semibold text-[#F56522]">
                {dayjs(item.startTime * 1000).format('HH:mm')}
              </span>{' '}
              ngày{' '}
              <span className="font-semibold text-[#F56522]">
                {dayjs(item.startTime * 1000).format('DD/MM/YYYY')}
              </span>
            </p>
          </div>
        );
      });
      if (!itemMatch || itemMatch.length <= 0) {
        return (
          <div className="flex flex-col items-center justify-center py-8">
            <InboxOutlined className="text-6xl text-gray-300 mb-4" />
            <p className="text-center text-gray-500">Không có trận đấu nào để dự đoán</p>
          </div>
        );
      } else {
        return (
          <div className="w-full h-full grid grid-cols-1 gap-6 mt-2 md:px-3 items-center justify-center">
            {itemMatch}
          </div>
        );
      }
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <img
        src="/assets/images/bao.png"
        alt=""
        className="pointer-events-none fixed bottom-[60px] left-[32px] z-[1] hidden lg:block"
      />
      <img
        src="/assets/images/chim.png"
        alt=""
        className="pointer-events-none fixed bottom-[55px] right-[20px] z-[1] hidden lg:block"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />

        <div
          className="mx-auto mt-2 max-w-[1200px] bg-white/95 border-2 border-solid shadow shadow-primary p-2 w-full md:pb-8 md:pt-4 rounded-3xl"
          style={{
            background: '#FFFFFF',
            borderColor: '#FB8C00',
            borderRadius: '1.5rem'
          }}
        >
          <div className="flex space-x-6 mt-4 justify-center items-center">
            <Button
              type="link"
              icon={<LeftOutlined />}
              onClick={scrollLeft}
              className="text-black  !px-0 !mx-0"
            />
            <div
              className="flex overflow-x-auto scrollbar-custom pb-2 !mx-0"
              ref={leagueListRef}
              style={{ scrollBehavior: 'smooth' }}
            >
              {leagues.map((league) => (
                <div
                  key={league.id}
                  className={twMerge(
                    'flex justify-center items-center p-1 mx-2 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105',
                    selectedLeagues.includes(league.id)
                      ? 'bg-gradient-to-br from-[#f27121] to-[#63c8f2] shadow-lg shadow-[#63c8f2] border-2 border-[#f27121]'
                      : 'bg-white/80 backdrop-blur-sm border-2 border-[#f27121]/30 hover:border-[#f27121] hover:shadow-md'
                  )}
                  style={{ width: '80px', minWidth: '80px', border: '1px solid #f27121' }}
                  onClick={() => handleLeagueClick(league.id)}
                >
                  <img src={league.logo} alt={league.name} className="h-12 object-contain" />
                </div>
              ))}
            </div>
            <Button
              type="link"
              icon={<RightOutlined />}
              onClick={scrollRight}
              className="text-black !px-0 !mx-0"
            />
          </div>

          {/* Đồng hồ đếm ngược World Cup 2026 — Figma 155-1206 (md+) / 155-1207 (<md) */}
          <div className="mx-auto mt-2 w-full max-w-[885px] pb-2 md:pb-3">
            <div className="relative overflow-hidden rounded-2xl border-[2px] border-solid border-[#FB8C00] shadow-sm backdrop-blur-[12px]">
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat md:hidden"
                style={{ backgroundImage: `url("${pub('/assets/images/header/cd_bg_mb.png')}")` }}
                aria-hidden
              />
              <div
                className="absolute inset-0 hidden bg-cover bg-center bg-no-repeat md:block"
                style={{ backgroundImage: `url("${pub('/assets/images/header/cd_bg.png')}")` }}
                aria-hidden
              />
              <div className="relative z-[1] flex min-h-[63px] w-full flex-row items-center justify-between gap-2 px-2 py-1.5 md:min-h-[86px] md:gap-4 md:px-6 md:py-1">
                <img
                  src={pub('/assets/images/header/cd_left.png')}
                  alt="FIFA World Cup 2026"
                  className="h-[50px] md:h-[68px] w-auto max-w-[45%] shrink-0 object-contain object-left md:h-[86px] md:max-w-none"
                  draggable={false}
                />
                <img
                  src={pub('/assets/images/header/cd_center.png')}
                  alt=""
                  className="hidden h-auto max-h-[68px] w-auto shrink object-contain md:block"
                  draggable={false}
                />
                <CountDownFinal />
              </div>
            </div>
          </div>

          <div className="relative w-full h-full">
            <Form
              name="formMatch"
              onFinish={onFinishForm}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
              initialValues={{ account: '' }}
            >
              <div className="w-full h-full">
                {isLoading ? (
                  <div className="w-full h-full text-center py-8">
                    <Spin />
                  </div>
                ) : (
                  <div className="flex flex-col w-full h-full items-center mt-3">
                    <div className="flex w-full h-full items-center justify-center flex-row gap-2 md:mx-3 md:flex-row">
                      <div className="w-full md:w-auto md:px-0 md:ml-3">
                        <div className="flex w-full max-w-full flex-nowrap items-center gap-1 sm:gap-1.5 md:gap-3 justify-center md:justify-start">
                          {[
                            { key: 'all', label: 'Tất Cả', minW: 'md:min-w-[92px]' },
                            { key: 'today', label: 'Hôm Nay', minW: 'md:min-w-[110px]' },
                            { key: 'tomorrow', label: 'Ngày Mai', minW: 'md:min-w-[111px]' }
                          ].map(({ key, label, minW }) => {
                            const isActive = activeTab === key;
                            return (
                              <button
                                key={key}
                                type="button"
                                onClick={() => setActiveTab(key)}
                                className={twMerge(
                                  'min-w-0 flex-1 basis-0 md:flex-none md:basis-auto h-8 md:h-10 rounded-[16px] md:rounded-[25px] px-1 sm:px-1.5 md:px-6 text-[9px] sm:text-[10px] md:text-[15px] leading-[11px] sm:leading-[12px] md:leading-[18px] font-normal whitespace-nowrap transition-colors flex items-center justify-center border-none',
                                  minW,
                                  isActive
                                    ? 'text-white bg-[#F56522] shadow-[inset_0px_0px_4px_0px_rgba(255,255,255,1)]'
                                    : 'text-[#3C3C3C] bg-[#EFEFEF]'
                                )}
                              >
                                {label}
                              </button>
                            );
                          })}
                          <button
                            type="button"
                            onClick={() => setIsHotScheduleOpen(true)}
                            className="min-w-0 flex-1 basis-0 md:flex-none md:basis-auto md:min-w-[100px] h-8 md:h-10 rounded-[16px] md:rounded-[25px] px-1 sm:px-1.5 md:px-6 text-[9px] sm:text-[10px] md:text-[15px] leading-[11px] sm:leading-[12px] md:leading-[18px] font-normal whitespace-nowrap text-white bg-[#F56522] shadow-[inset_0px_0px_4px_0px_rgba(255,255,255,1)] flex items-center justify-center border-none"
                          >
                            Lịch Thi Đấu
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="flex mt-2 py-1 md:py-2">
                      <Form.Item name="account" className="mb-0">
                        <Input
                          placeholder="Nhập tên đăng nhập ..."
                          maxLength={20}
                          className="h-[36px] w-[180px] rounded-l-[30px] rounded-r-none border-[#c9c9c9] text-[12px] px-[17px] py-[10px]"
                          style={{
                            borderRight: 'none'
                          }}
                          rules={[
                            {
                              required: true,
                              message: 'Vui lòng điền tên đăng nhập!'
                            }
                          ]}
                        />
                      </Form.Item>
                      <Form.Item className="mb-0 items-center justify-center md:mr-3">
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={isLoadingSubmit}
                          className="text-white font-semibold rounded-l-none rounded-r-[30px] border-0 h-[36px] w-[100px] md:w-[124px] text-[12px] md:text-[14px]"
                          style={{
                            background: '#f27121'
                          }}
                        >
                          Xác nhận
                        </Button>
                      </Form.Item>
                    </div>
                    <div id="match-schedule-section" className="w-full h-full scroll-mt-4 mt-2">
                      {showListItemMatch(getFilteredMatches())}
                    </div>
                  </div>
                )}
                <div className="flex items-center justify-between mt-2"></div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <HotScheduleModal open={isHotScheduleOpen} onClose={() => setIsHotScheduleOpen(false)} />
    </div>
  );
};

export default HomePage;
